package com.exura.ui

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.*


data class ExuraRgba(
    val r: Number,
    val g: Number,
    val b: Number,
    val alpha: Number,
) {
    val rgba = rgba(r, g, b, alpha)
}

object ExuraColors {

    val LIGHT_GRAY = ExuraRgba(188, 193, 202, 1)
    val LIGHT_GRAY3 = ExuraRgba(188, 193, 202, 1)
    val GRAY = ExuraRgba(232, 236, 244, 1)
    val ARSENIC = ExuraRgba(61, 65, 68, 1)
    val ARSENIC2 = ExuraRgba(142, 141, 146, 1)
    val BLUE = ExuraRgba(62, 118, 234, 1)
    val BLUE2 = ExuraRgba(109, 130, 255, 1)
    val BLUE3 = ExuraRgba(110, 130, 255, 0.1)
    val BLUE_DARK = ExuraRgba(30, 43, 82, 1)
    val LIGHT_BLUE = ExuraRgba(231, 238, 248, 1)
    val TURQUOISE = ExuraRgba(51, 176, 216, 1)
    val ORANGE = ExuraRgba(255, 186, 93, 1)


    val WHITE = ExuraRgba(255, 255, 255, 1)
    val BLACK = ExuraRgba(0, 0, 0, 1)

    val YELLOW = ExuraRgba(255, 186, 93, 1)
    val RED = ExuraRgba(255, 93, 93, 1)
    val GREEN = ExuraRgba(104, 179, 0, 0.8)

    val TRANSPARENT = ExuraRgba(255, 255, 255, 0)

    val QUESTION = YELLOW
    val PERSISTENT = RED
    val DYNAMIC = GREEN
    val INSTRUCTION = BLUE

}


fun Modifier.background(color: ExuraRgba) = background(color.rgba)

fun Modifier.backgroundColor(color: ExuraRgba) = backgroundColor(color.rgba)

fun Modifier.color(color: ExuraRgba) = color(color.rgba)


fun BorderScope.color(color: ExuraRgba) = color(color.rgba)

fun BorderScope.color(
    top: ExuraRgba,
    right: ExuraRgba,
    bottom: ExuraRgba,
    left: ExuraRgba,
) = color(top = top.rgba, right = right.rgba, bottom = bottom.rgba, left = left.rgba)

fun BorderScope.color(
    topBottom: ExuraRgba,
    leftRight: ExuraRgba,
) = color(topBottom = topBottom.rgba, leftRight = leftRight.rgba)


fun StyleScope.color(value: ExuraRgba) = color(value.rgba)
